<template>
	<ui-slideover v-on:close="$emit('close')" title="Filter by">
		<slot>
			<div class="flex flex-col h-full divide-y divide-gray-200 border-t">
				<ui-filter-renderer
					:filter="filter"
					:filter-options="filterOptions"
					v-on:select-my-products="selectMyProducts()"
					v-on:filter-clear="clearFilters()"
					v-on:filter-close="$emit('close')"
				/>
			</div>
		</slot>
	</ui-slideover>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		value: {
			type: Object,
		},
		filterOptions: {
			type: Object,
			required: true,
		},
	},
	data() {
		let productGrade = this.filterOptions.productGrades,
			allGradesIds = [];
		Object.keys(productGrade).forEach(function (option) {
			allGradesIds.push(productGrade[option].value);
		});
		let userFavoriteProductGrades = allGradesIds.filter((g) =>
			this.checkFavouriteProductInFilter(g)
		);
		return {
			emptyFilter: {
				productGrades: [],
				productYears: [],
				contractSources: [],
				type: "SELL",
			},
			filter: Object.assign({}, this.value),
			userFavoriteProductGrades: userFavoriteProductGrades,
		};
	},
	computed: {},
	watch: {
		filter: {
			deep: true,
			handler: function (val) {
				console.log("THERE");

				this.$emit("input", val);
				console.log("EMIT", val);
			},
		},
	},
	methods: {
		clearFilters() {
			this.filter = JSON.parse(JSON.stringify(this.emptyFilter));
		},
		selectMyProducts() {
			this.filter.productGrades = this.userFavoriteProductGrades;
		},
		checkFavouriteProductInFilter(type) {
			let favouriteTypes = this.$inertia.page.props.user.favorite_product_types,
				flag = false;
			Object.keys(favouriteTypes).forEach(function (option) {
				if (type.includes(favouriteTypes[option])) {
					flag = true;
				}
			});
			return flag;
		},
	},
};
</script>
